// Copyright (c) 2020 Deere & Company

import AdditionalDetailsDataTestDomain, {getDefaultState as getAdditionalDataTestDomain} from './additional-data-test-domain';
import AdditionalDetailsDataTypeDomain, {getDefaultState as getAdditionalDataTypeDomain} from './additional-data-type-domain';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import RgaAdditionalDataInfo, {getDefaultState as getAdditionalDataInfoDefaultState} from './rga-additional-data-info';
import RgaConsignmentDetails, {getDefaultState as getRgaConsignmentDefaultState} from './rga-consignment-details';
import RgaDealerDetails, {getDefaultState as getRgaDealerDefaultState} from './rga-dealer-details';
import RgaDetails, {getDefaultState as getRgaDefaultState} from './rga-details';
import RgaQandA, {getDefaultState as getRgaQandADefaultState} from './rga-q-and-a';
import FileList from './files-list';
import RgaSearchResultList from './rga-search-result-list';
import RgaSelectedMassUpdateList from './rga-selected-mass-update-list';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const RgaSearchResult = t.struct({
    additionalDataFlag: t.maybe(t.Boolean),
    additionalDataInfo: RgaAdditionalDataInfo,
    additionalDataTestDomain: AdditionalDetailsDataTestDomain,
    additionalDataTypeDomain: AdditionalDetailsDataTypeDomain,
    busyCounter: BusyCounter,
    file: FileList,
    isEmptyRgaSearchResult: t.maybe(t.Boolean),
    rgaConsignmentDetails: RgaConsignmentDetails,
    rgaDealerDetails: RgaDealerDetails,
    rgaDetails: RgaDetails,
    rgaQandA: RgaQandA,
    rgaSearchResultList: RgaSearchResultList,
    rgaSelectedMassUpdate: RgaSelectedMassUpdateList,
    searchFilters: SearchFilters
}, {
    name: 'RgaSearchResult',
    strict: true
});

export const getDefaultState = () =>
    new RgaSearchResult({
        additionalDataFlag: false,
        additionalDataInfo: getAdditionalDataInfoDefaultState(),
        additionalDataTestDomain: getAdditionalDataTestDomain(),
        additionalDataTypeDomain: getAdditionalDataTypeDomain(),
        busyCounter: getBusyCounterDefaultState(),
        file: [],
        isEmptyRgaSearchResult: false,
        rgaConsignmentDetails: getRgaConsignmentDefaultState(),
        rgaDealerDetails: getRgaDealerDefaultState(),
        rgaDetails: getRgaDefaultState(),
        rgaQandA: getRgaQandADefaultState(),
        rgaSearchResultList: [],
        rgaSelectedMassUpdate: [],
        searchFilters: getSearchFiltersDefaultState()
    });

export default RgaSearchResult;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/index.js